import React from "react";
import "./App.css";
import RouteStart from "./routing";

const App: React.FC = () => {
  return <RouteStart />;
};

export default App;
